import React, { useEffect, useState } from 'react'
import SearchContainer from './SearchConatiner';
import DrugExclusionTable from './DrugExclusionTable';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import ErrorBoundary from 'components/ErrorBoundary'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useContextService from 'hooks/useContextService'
import useAxios from 'hooks/useAxios';
import { cloneDeep } from 'lodash';

const DrugExclusion = (props) => {
  const API = useAxios();
  const {  orgId,reset,tabKey
         } = props;

  const {
    states: { drugExclusion },
    setStates,
} = useContextService();
const { search, coveredEntity, searchTerms, claimStatusID } = drugExclusion;
const [resetFilterFlag, SetResetFilterFlag]= useState(false);
useEffect(() => {
  handleReset();
}, [orgId, reset]);

const handleReset = () => {
  setcollapseSider(false);
  setData([]);
  setTotalItem(0);
  SetResetFilterFlag(true);
};


useEffect(() => {
  if (searchTerms.coveredEntityID) handleSearch(searchTerms);
  onReset();
}, []);
const onReset = () => {
  setcollapseSider(false);
  setData([]);
  setTotalItem(0);
};
// const refetch = () => {
//   handleSearch(searchTerms);
// };

const refetch = ()=>{
  debugger;
  drugExclusion.search.currentPage=1;
  // if(value)
    //search.CeId = parseInt(value1);
    // search.Hospital = parseInt(value2);
  fetchDrugExclusionAll(search)
}

const handleSubmit1 = (value) => {
  debugger;
  const filters = {
    AccumulatorID: 1,
    // HospitalDD: parseInt(value),
    currentPage: 1,
    filters: [],
    order: "desc",
    orderBy: "modifiedDate",
    pageSize: 10
  };

  fetchDrugExclusionAll(filters);
  //handleSearch(filters);
};

// const refetch=(hasfetch)=>{
//   debugger;
//   let filter  = {};
//   let acids = [];
//   if(hasfetch){
//     var rw = searchTerms.accumulationIDs[0];
//     acids.push(rw.value);
//     filter.accumulationIDs = acids;
//     // filter.mapstatus = searchTerms.mappingStatus;
//     handleSearch(filter);
//   }

// }

const handleSearch = async (ceid) => {
  debugger;
 // const {  CoveredEntityIDs } = filter;

  const tableRes = document.querySelector(".table-responsive");
  tableRes.scrollLeft = 0;

  // search.AccumulatorID = accumulationIDs[0];
  search.CeId = ceid;
  // search.Hospital = parseInt(hospitalDD);
  if(tabKey === "drugexclusion")
  await fetchDrugExclusionAll(search);
};

const fetchDrugExclusionAll = async (filters) => {
  debugger;
  if (!orgId?.tenantID) return null;
  if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
  try {
    if (filters.CeId > 0)
    {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/DrugCatalog/GetExclusionAll`,
        filters,
        { hasDefaultURL: true }
      );
      
      if (data?.items?.length > 0) {
        setData(data.items);
        setCollIcon(faAngleDown);
        setTotalItem(data.totalRecords);
      } else {
        setData([]);
        setTotalItem(0);
      }
    }
  } catch (error) {}
};
    const [WAC, setWac] = useState(false);
    const [GpoPrice, setGpoPrice] = useState(false);
    const [PriceB , setPriceB] = useState(false);
    const [collapseSider, setcollapseSider] = useState(false);
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [data,setData] = useState([]);
    const[totalitem,setTotalItem] = useState(0);

    const toggleWacDetails = () => {
        setWac(!WAC);
      };
      const toggleWGpoDetails = () => {
        setGpoPrice(!GpoPrice);
      };
      const toggle340Betails = () => {
        setPriceB(!PriceB);
      };

      const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
      }
      const handlePageChange = (filter, haveColFilter) => {
        updatedrugExclusionSearch(filter);
        if (haveColFilter) {
            const filterObj = cloneDeep(search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;
            filterObj.orderBy= filter.orderBy;
            filterObj.order= filter.order;

            drugExclusion.search = { ...drugExclusion.search };
            fetchDrugExclusionAll(filterObj);
  
        } else {
          fetchDrugExclusionAll(filter);
            drugExclusion.search = { ...drugExclusion.search, ...filter };
        }
        setStates('drugExclusion', drugExclusion);
    };

     const updatedrugExclusionSearch = (filter) => {
      drugExclusion.search.currentPage = filter.currentPage;
      drugExclusion.search.pageSize = filter.pageSize;
      drugExclusion.search.orderBy= filter.orderBy;
      drugExclusion.search.order= filter.order;
  }

    const handleSearchColumnFilters = async (columnFilters) => {
      const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
          filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
      drugExclusion.search.currentPage=1;
      filterObj.currentPage=1;
      await fetchDrugExclusionAll(filterObj);
  };
  const handleSearchColumnFiltersClear = () => {
    setColumnFilters([]);
  };

  return (
    <div>
      <div className='border-0'>
        <Card className="border-0  shadow-top drug_tabs">
          <CardBody hidden={collapseSider} className="">
            <ErrorBoundary>
              <SearchContainer
                orgId={orgId}
                onSearch={handleSearch}
                refetch={refetch}
                filters={search}
                handleSubmit1={handleSubmit1}
                onReset={handleReset}
                reset={reset}
              />
            </ErrorBoundary>
          </CardBody>
          </Card>
          <Card className='border-0 shadow-top mt-2'>
          <CardBody>
          <div className='pt-0'>

            <ErrorBoundary>
              <DrugExclusionTable
                toggleWacDetails={toggleWacDetails}
                toggle340Betails={toggle340Betails}
                toggleWGpoDetails={toggleWGpoDetails}
                data={data}
                filters={search}
                totalitem={totalitem}
                // manvalConfigedit={manvalConfigedit}
                // rowData={rowData}
                orgId={orgId}
                onPageChange={handlePageChange}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                onSearchColumnFiltersClear={handleSearchColumnFiltersClear}
                fetchDrugExclusionAll={fetchDrugExclusionAll}
                collapseSider={collapseSider}
                toggleSider={toggleSider}
                resetFilterFlag={resetFilterFlag}
                SetResetFilterFlag={SetResetFilterFlag}
                tabKey={tabKey}
              />
            </ErrorBoundary>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
}

export default DrugExclusion